import jsPDF from "jspdf";

const COLOR_MAIN = [14, 122, 237];
const COLOR_DARK = [67, 70, 86];
const COLOR_MUTED = [142, 142, 142];
const COLOR_DIVIDER = [230, 230, 230];

const SECTIONS = [
    { key: "ai", label: "AI Model" },
    { key: "tts", label: "Text-to-Speech" },
    { key: "stt", label: "Speech-to-Text" },
    { key: "externalApis", label: "External APIs" },
];

function hexToRgb(hex) {
    return [
        parseInt(hex.slice(1, 3), 16),
        parseInt(hex.slice(3, 5), 16),
        parseInt(hex.slice(5, 7), 16),
    ];
}

function lighten(rgb, ratio) {
    return rgb.map((channel) => Math.round(255 - (255 - channel) * ratio));
}

function formatGeneratedDate() {
    return new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
}

function exportBotProfilPdf(companyName, bots) {
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 16;
    const marginRight = 16;
    let y = 20;

    const ensureSpace = (needed) => {
        if (y + needed > pageHeight - 15) {
            doc.addPage();
            y = 20;
        }
    };

    const drawBlockBadge = (block) => {
        if (!block) return;
        const rgb = hexToRgb(block.color);
        const paddingX = 3;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        const badgeWidth = doc.getTextWidth(block.name) + paddingX * 2;
        const badgeHeight = 5;
        const badgeX = pageWidth - marginRight - badgeWidth;
        const badgeY = y - 3.6;

        doc.setFillColor(...lighten(rgb, 0.18));
        doc.setDrawColor(...rgb);
        doc.setLineWidth(0.2);
        doc.roundedRect(badgeX, badgeY, badgeWidth, badgeHeight, 1.5, 1.5, "FD");

        doc.setTextColor(...rgb);
        doc.text(block.name, badgeX + paddingX, y);
    };

    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.setTextColor(...COLOR_DARK);
    doc.text(companyName, marginLeft, y);
    y += 10;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...COLOR_MUTED);
    doc.text(`Bot profiles summary - generated on ${formatGeneratedDate()}`, marginLeft, y);
    y += 4;

    doc.setDrawColor(...COLOR_MAIN);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 10;

    bots.forEach((bot, botIndex) => {
        ensureSpace(20);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.setTextColor(...COLOR_DARK);
        doc.text(bot.name, marginLeft, y);
        y += 7;

        SECTIONS.forEach(({ key, label }) => {
            if (key !== "ai") {
                y += 2.5;
            }
            const items = bot[key] || [];
            ensureSpace(30);


            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.setTextColor(...COLOR_MAIN);
            doc.text(label.toUpperCase(), marginLeft + 2, y);
            y += 7;

            if (items.length === 0) {
                doc.setFont("helvetica", "italic");
                doc.setFontSize(10);
                doc.setTextColor(...COLOR_MUTED);
                doc.text(`No ${label.toLowerCase()} configured for this bot.`, marginLeft + 4, y);
                y += 9;
                return;
            }

            items.forEach((item) => {
                ensureSpace(8);
                const blocks = item.blocks || (item.block ? [item.block] : []);
                const vendor = item.provider || item.vendor || item.host;
                const detail = item.model || item.url || (blocks.length > 0 ? `${blocks.length} block${blocks.length > 1 ? "s" : ""}` : "");

                doc.setFont("helvetica", "normal");
                doc.setFontSize(10);
                doc.setTextColor(...COLOR_DARK);
                doc.text(`• ${vendor}${detail ? ` - ${detail}` : ""}`, marginLeft + 4, y);

                if (blocks.length === 1) {
                    drawBlockBadge(blocks[0]);
                }
                y += 8;

                if (blocks.length > 1) {
                    ensureSpace(6);
                    doc.setFont("helvetica", "italic");
                    doc.setFontSize(8);
                    doc.setTextColor(...COLOR_MUTED);
                    doc.text(blocks.map((b) => b.name).join(", "), marginLeft + 8, y);
                    y += 7;
                }
            });

            y += 6;
        });

        if (botIndex !== bots.length - 1) {
            ensureSpace(8);
            doc.setDrawColor(...COLOR_DIVIDER);
            doc.setLineWidth(0.3);
            doc.line(marginLeft, y, pageWidth - marginRight, y);
            y += 8;
        }
    });

    const fileName = bots.length === 1
        ? `${companyName.replace(/\s+/g, "_")}_${bots[0].name.replace(/\s+/g, "_")}_bot_profile.pdf`
        : `${companyName.replace(/\s+/g, "_")}_bot_profiles.pdf`;
    doc.save(fileName);
}

export default exportBotProfilPdf;
